module.exports = __webpack_public_path__ + "media/images/app/metatag-bf9f72afd619e502c44c304ee54718a6.png";